import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  Steps,
  Button,
  Typography,
  Spin,
  message,
  Row,
  Col,
  Select,
  InputNumber,
  DatePicker,
  Table,
  Alert,
  Tag,
  Switch,
  Input,
  Divider,
} from "antd";
import { CheckCircleFilled, TableOutlined, ClockCircleOutlined } from "@ant-design/icons";
import {
  IconCalendarCog,
  IconCalendar,
  IconCash,
  IconFile,
  IconStack,
  IconFall,
  IconBook,
  IconCalculator,
  IconInvoice,
} from "../../../Icons/Icons";
import IconBiwo from "../../../Icons/IconBiwo";
import AgregarRegistroPatronal from "../RegistroPatronal/AgregarRegistroPatronal/AgregarRegistroPatronal";
import "./ConfiguracionInicialWizard.css";

const { Title, Text } = Typography;
const { Option } = Select;

const PASOS_RESUMEN = [
  { icon: <IconCalendarCog size={20} />, titulo: "Tipos de Periodo", descripcion: "Selecciona qué periodicidades de pago manejas." },
  { icon: <IconCalendar size={20} />, titulo: "Configurar Periodos", descripcion: "Define los días de inicio. Se crean 2 años de periodos automáticamente." },
  { icon: <IconStack size={20} />, titulo: "Tipos Acumulados", descripcion: "Acumulados estándar para el cálculo anual de ISR e IMSS." },
  { icon: <IconFall size={20} />, titulo: "Tipos de Incidencias", descripcion: "Faltas, incapacidades, vacaciones y más, definidas por la LFT." },
  { icon: <IconCash size={20} />, titulo: "Tipo de Prestaciones", descripcion: "Paquetes de prestaciones base que establece la Ley Federal del Trabajo." },
  { icon: <IconBook size={20} />, titulo: "Conceptos de Ley", descripcion: "Percepciones, deducciones y obligaciones de nómina definidas por la ley." },
  { icon: <IconInvoice size={20} />, titulo: "Configuración General", descripcion: "Póliza contable, cálculo de ISR, ajuste de neto, IMSS y Fonacot." },
  { icon: <IconCalculator size={20} />, titulo: "Configuración Contable", descripcion: "Revisa las cuentas contables que se asignarán a cada concepto de nómina." },
  { icon: <IconFile size={20} />, titulo: "Registro Patronal", descripcion: "Configura el número de registro patronal del IMSS." },
  { icon: <ClockCircleOutlined style={{ fontSize: 20 }} />, titulo: "Turno", descripcion: "Define al menos un turno de trabajo para tus empleados." },
  { icon: <TableOutlined style={{ fontSize: 20 }} />, titulo: "Tablas SAT", descripcion: "ISR, subsidio al empleo, UMA y más, ya disponibles en BIWO." },
];

const getDisabledDate = (key, cfg) => {
  if (key === "semanal" || key === "catorcenal") {
    return (d) => d.day() !== cfg.diaInicioDeSemana;
  }
  if (key === "mensual") {
    return (d) => d.date() !== cfg.diaInicio;
  }
  if (key === "quincenal") {
    // Las quincenas van del 1 al 15 y del 16 al fin de mes: se arranca en el 1 o
    // en el 16. Arrancar el 15 dejaba un primer periodo de un solo día (15 al 15).
    return (d) => d.date() !== 1 && d.date() !== 16;
  }
  return undefined;
};

const TIPOS_PERIODO = [
  { key: "semanal", label: "Semanal", descripcion: "7 días, pago semanal" },
  { key: "quincenal", label: "Quincenal", descripcion: "Del 1 al 15 y del 16 al fin de mes" },
  { key: "catorcenal", label: "Catorcenal", descripcion: "14 días, pago cada dos semanas" },
  { key: "mensual", label: "Mensual", descripcion: "Pago mensual" },
];

const DIAS_SEMANA = [
  { value: 1, label: "Lunes" },
  { value: 2, label: "Martes" },
  { value: 3, label: "Miércoles" },
  { value: 4, label: "Jueves" },
  { value: 5, label: "Viernes" },
  { value: 6, label: "Sábado" },
  { value: 0, label: "Domingo" },
];

class ConfiguracionInicialWizard extends Component {
  _timer = null;

  constructor(props) {
    super(props);
    this.state = {
      // animation — en reingreso (la empresa ya está configurada) se omite la intro
      showAnim: !props.reingreso,
      animPhase: 0,
      // wizard
      currentStep: 0,
      tiposSeleccionados: [],
      tipoActualIdx: 0,
      configuraciones: {
        semanal: { diaInicioDeSemana: 1, fechaInicio: null },
        quincenal: { fechaInicio: null },
        catorcenal: { diaInicioDeSemana: 1, fechaInicio: null },
        mensual: { diaInicio: 1, fechaInicio: null },
      },
      guardandoPeriodos: false,
      // step 3 - acumulados
      acumulados: [],
      loadingAcumulados: false,
      guardandoAcumulados: false,
      // step 4 - incidencias
      incidencias: [],
      loadingIncidencias: false,
      guardandoIncidencias: false,
      // step 5 - prestaciones
      prestaciones: [],
      loadingPrestaciones: false,
      guardandoPrestaciones: false,
      // step 6 - conceptos de ley
      conceptos: [],
      resumenConceptos: null,
      loadingConceptos: false,
      guardandoConceptos: false,
      // step 7 - configuración general de nómina (póliza, ISR, ajuste de neto, IMSS, Fonacot)
      polizaConfigCargada: false,
      loadingPolizaConfig: false,
      guardandoPolizaConfig: false,
      tiposDePolizasWizard: [],
      proyectosWizard: [],
      polizaConfigTipoDePolizaId: undefined,
      polizaConfigProyectoId: undefined,
      polizaConfigPorEmpleado: false,
      polizaConfigDesactivarObligaciones: false,
      polizaConfigNetearSubsEntregado: false,
      polizaConfigMetodoISR: "SP",
      polizaConfigAjustarISRRetenidoMenos: true,
      polizaConfigAjustarISRRetenidoMas: true,
      polizaConfigAjustarSubsCausadoMenos: false,
      polizaConfigAplicarSubsidioArt174: false,
      polizaConfigEducacion1Pct: false,
      polizaConfigMultiploAjusteNeto: 0.2,
      polizaConfigPreferenciaAjusteNetoNegativo: true,
      polizaConfigPrimaRiesgoTrabajo: 0.005,
      polizaConfigZonaMinimo: "A",
      polizaConfigCentroTrabajoFonacot: "",
      polizaConfigNumeroFonacot: "",
      // step 8 - configuración contable
      resumenContable: [],
      resumenContableTotales: null,
      resumenContablePrestamos: [],
      loadingResumenContable: false,
      guardandoResumenContable: false,
      // step 8 - registro patronal
      modalRegistroPatronal: false,
      registroPatronalAgregado: false,
      // step 9 - turno
      turnos: [],
      loadingTurnos: false,
      guardandoTurnos: false,
      // step 10 - tablas
      tablas: [],
      loadingTablas: false,
    };
  }

  componentDidMount() {
    if (this.state.showAnim) this._playAnimation();
  }

  componentWillUnmount() {
    if (this._timer) clearTimeout(this._timer);
  }

  _schedule(fn, ms) { this._timer = setTimeout(fn, ms); }

  _playAnimation() {
    this._schedule(() => {
      this.setState({ animPhase: 1 });
      this._schedule(() => {
        this.setState({ animPhase: 2 });
        this._schedule(() => {
          this.setState({ animPhase: 3 });
          this._schedule(() => {
            this.setState({ animPhase: 4 });
            this._schedule(() => {
              this.setState({ animPhase: 5 });
              this._schedule(() => {
                this.setState({ showAnim: false });
              }, 1100);
            }, 1100);
          }, 800);
        }, 700);
      }, 550);
    }, 300);
  }

  _skip = () => {
    if (this._timer) clearTimeout(this._timer);
    this.setState({ showAnim: false });
  };

  componentDidUpdate(_, prevState) {
    const { currentStep } = this.state;

    if (prevState.currentStep !== currentStep) {
      if (currentStep === 3 && this.state.acumulados.length === 0) this.cargarAcumuladosDeLey();
      if (currentStep === 4 && this.state.incidencias.length === 0) this.cargarIncidenciasDeLey();
      if (currentStep === 5 && this.state.prestaciones.length === 0) this.cargarPrestacionesDeLey();
      // Sin el guard de length: la tabla del paso 6 muestra el estado de alta de cada concepto
      // (por agregar / ya existe / por corregir), así que hay que recalcularlo cada vez que se
      // entra al paso o quedaría desfasado después de guardar.
      if (currentStep === 6) this.cargarConceptosDeLey();
      if (currentStep === 7 && !this.state.polizaConfigCargada) this.cargarPolizaConfig();
      // Igual que el paso 6: la tabla muestra qué se va a asignar y qué se respeta, así que
      // hay que recalcularlo cada vez que se entra o quedaría desfasado después de guardar.
      if (currentStep === 8) this.cargarResumenContableDeLey();
      if (currentStep === 10 && this.state.turnos.length === 0) this.cargarTurnos();
      if (currentStep === 11 && this.state.tablas.length === 0) this.cargarTablasGlobales();
    }
  }

  toggleTipo(key) {
    this.setState((prev) => {
      const sel = prev.tiposSeleccionados;
      return { tiposSeleccionados: sel.includes(key) ? sel.filter((t) => t !== key) : [...sel, key] };
    });
  }

  setConfiguracion(tipo, campo, valor) {
    this.setState((prev) => {
      const updated = { ...prev.configuraciones[tipo], [campo]: valor };
      if (campo === "diaInicioDeSemana" || campo === "diaInicio") {
        updated.fechaInicio = null;
      }
      return { configuraciones: { ...prev.configuraciones, [tipo]: updated } };
    });
  }

  guardarPeriodos() {
    const { tiposSeleccionados, configuraciones } = this.state;
    this.setState({ guardandoPeriodos: true });
    Promise.all([
      ...tiposSeleccionados.map((tipo) => {
        const { fechaInicio, ...rest } = configuraciones[tipo];
        return axios.post(
          "wizardNominas/agregarTipoPeriodoWizard",
          { tipo, ...rest, fechaInicio: fechaInicio ? fechaInicio.format("YYYY-MM-DD") : null, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        );
      }),
      axios.post(
        "wizardNominas/asegurarTipoPeriodoExtraordinario",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ])
      .then((results) => {
        const failed = results.find((r) => r.data.success !== 2);
        if (failed) { message.error(failed.data.message || "No se pudo guardar el tipo de periodo"); this.setState({ guardandoPeriodos: false }); }
        else this.setState({ guardandoPeriodos: false, currentStep: 3 });
      })
      .catch(() => { message.error("Error al guardar los tipos de periodo"); this.setState({ guardandoPeriodos: false }); });
  }

  cargarAcumuladosDeLey() {
    this.setState({ loadingAcumulados: true });
    axios.post("wizardNominas/selectTiposAcumuladosDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ loadingAcumulados: false, acumulados: res.data.data });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingAcumulados: false }); }
      })
      .catch(() => { message.error("Error al cargar tipos acumulados"); this.setState({ loadingAcumulados: false }); });
  }

  guardarAcumulados() {
    this.setState({ guardandoAcumulados: true });
    axios.post("wizardNominas/agregarTiposAcumuladosDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ guardandoAcumulados: false, currentStep: 4 });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ guardandoAcumulados: false }); }
      })
      .catch(() => { message.error("Error al guardar tipos acumulados"); this.setState({ guardandoAcumulados: false }); });
  }

  cargarIncidenciasDeLey() {
    this.setState({ loadingIncidencias: true });
    axios.post("wizardNominas/selectTiposIncidenciasDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ loadingIncidencias: false, incidencias: res.data.data });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingIncidencias: false }); }
      })
      .catch(() => { message.error("Error al cargar tipos de incidencias"); this.setState({ loadingIncidencias: false }); });
  }

  guardarIncidencias() {
    this.setState({ guardandoIncidencias: true });
    axios.post("wizardNominas/agregarTiposIncidenciasDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ guardandoIncidencias: false, currentStep: 5 });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ guardandoIncidencias: false }); }
      })
      .catch(() => { message.error("Error al guardar tipos de incidencias"); this.setState({ guardandoIncidencias: false }); });
  }

  cargarPrestacionesDeLey() {
    this.setState({ loadingPrestaciones: true });
    axios.post("wizardNominas/selectTiposPrestacionesDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ loadingPrestaciones: false, prestaciones: res.data.data });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingPrestaciones: false }); }
      })
      .catch(() => { message.error("Error al cargar tipos de prestaciones"); this.setState({ loadingPrestaciones: false }); });
  }

  guardarPrestaciones() {
    this.setState({ guardandoPrestaciones: true });
    axios.post("wizardNominas/agregarTiposPrestacionesDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ guardandoPrestaciones: false, currentStep: 6 });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ guardandoPrestaciones: false }); }
      })
      .catch(() => { message.error("Error al guardar tipos de prestaciones"); this.setState({ guardandoPrestaciones: false }); });
  }

  cargarConceptosDeLey() {
    this.setState({ loadingConceptos: true });
    axios.post("wizardNominas/selectConceptosDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingConceptos: false,
            conceptos: res.data.data,
            resumenConceptos: res.data.resumen || null,
          });
        }
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingConceptos: false }); }
      })
      .catch(() => { message.error("Error al cargar conceptos de ley"); this.setState({ loadingConceptos: false }); });
  }

  guardarConceptosDeLey() {
    this.setState({ guardandoConceptos: true });
    axios.post("wizardNominas/agregarConceptosDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const creados = res.data.creados ?? 0;
          const normalizados = res.data.normalizados ?? 0;
          const partes = [];
          if (creados > 0) partes.push(`${creados} concepto(s) agregado(s)`);
          if (normalizados > 0) partes.push(`${normalizados} corregido(s) para el Art. 174`);
          message.success(partes.length > 0 ? partes.join(" · ") : "Los conceptos de ley ya estaban al día");
          this.setState({ guardandoConceptos: false, currentStep: 7 });
        }
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ guardandoConceptos: false }); }
      })
      .catch(() => { message.error("Error al guardar conceptos de ley"); this.setState({ guardandoConceptos: false }); });
  }

  cargarPolizaConfig() {
    this.setState({ loadingPolizaConfig: true });
    Promise.all([
      axios.post("empresas/selectConfiguracionNomina", { empresaId: this.props.empresaId }, { headers: this.props.headersToken }),
      axios.post("tiposDePolizas/selectTiposDePolizas", { empresaId: this.props.empresaId }, { headers: this.props.headersToken }),
      axios.post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken }),
    ])
      .then(([resConfig, resTipos, resProyectos]) => {
        const c = (resConfig.data.success === 2 && resConfig.data.configuracionNomina) || {};
        this.setState({
          loadingPolizaConfig: false,
          polizaConfigCargada: true,
          polizaConfigTipoDePolizaId: c.tipoDePolizaId,
          polizaConfigProyectoId: c.proyectoId,
          polizaConfigPorEmpleado: !!c.polizaPorEmpleado,
          polizaConfigDesactivarObligaciones: !!c.desactivarMovimientosObligaciones,
          polizaConfigNetearSubsEntregado: !!c.netearSubsEntregado,
          polizaConfigMetodoISR: c.metodoISR || "SP",
          polizaConfigAjustarISRRetenidoMenos: c.ajustarISRRetenidoMenos !== false,
          polizaConfigAjustarISRRetenidoMas: c.ajustarISRRetenidoMas !== false,
          polizaConfigAjustarSubsCausadoMenos: !!c.ajustarSubsCausadoMenos,
          polizaConfigAplicarSubsidioArt174: !!c.aplicarSubsidioArt174,
          polizaConfigEducacion1Pct: !!c.educacion1Pct,
          polizaConfigMultiploAjusteNeto: c.multiploAjusteNeto ?? 0.2,
          polizaConfigPreferenciaAjusteNetoNegativo: c.preferenciaAjusteNetoNegativo !== false,
          polizaConfigPrimaRiesgoTrabajo: c.primaRiesgoTrabajo ?? 0.005,
          polizaConfigZonaMinimo: c.zonaMinimo || "A",
          polizaConfigCentroTrabajoFonacot: c.centroTrabajoFonacot || "",
          polizaConfigNumeroFonacot: c.numeroFonacot || "",
          tiposDePolizasWizard: resTipos.data.status === 404 ? [] : resTipos.data,
          proyectosWizard: resProyectos.data.status === 404 ? [] : resProyectos.data,
        });
      })
      .catch(() => {
        message.error("Error al cargar la configuración de póliza de nómina");
        this.setState({ loadingPolizaConfig: false, polizaConfigCargada: true });
      });
  }

  guardarPolizaConfig() {
    const {
      polizaConfigTipoDePolizaId, polizaConfigProyectoId, polizaConfigPorEmpleado, polizaConfigDesactivarObligaciones,
      polizaConfigNetearSubsEntregado, polizaConfigMetodoISR, polizaConfigAjustarISRRetenidoMenos,
      polizaConfigAjustarISRRetenidoMas, polizaConfigAjustarSubsCausadoMenos, polizaConfigEducacion1Pct,
      polizaConfigAplicarSubsidioArt174,
      polizaConfigMultiploAjusteNeto, polizaConfigPreferenciaAjusteNetoNegativo, polizaConfigPrimaRiesgoTrabajo,
      polizaConfigZonaMinimo, polizaConfigCentroTrabajoFonacot, polizaConfigNumeroFonacot,
    } = this.state;
    this.setState({ guardandoPolizaConfig: true });
    axios.post(
      "empresas/editarConfiguracionNomina",
      {
        empresaId: this.props.empresaId,
        tipoDePolizaId: polizaConfigTipoDePolizaId,
        proyectoId: polizaConfigProyectoId,
        polizaPorEmpleado: polizaConfigPorEmpleado,
        desactivarMovimientosObligaciones: polizaConfigDesactivarObligaciones,
        netearSubsEntregado: polizaConfigNetearSubsEntregado,
        metodoISR: polizaConfigMetodoISR,
        ajustarISRRetenidoMenos: polizaConfigAjustarISRRetenidoMenos,
        ajustarISRRetenidoMas: polizaConfigAjustarISRRetenidoMas,
        ajustarSubsCausadoMenos: polizaConfigAjustarSubsCausadoMenos,
        aplicarSubsidioArt174: polizaConfigAplicarSubsidioArt174,
        educacion1Pct: polizaConfigEducacion1Pct,
        multiploAjusteNeto: polizaConfigMultiploAjusteNeto,
        preferenciaAjusteNetoNegativo: polizaConfigPreferenciaAjusteNetoNegativo,
        primaRiesgoTrabajo: polizaConfigPrimaRiesgoTrabajo,
        zonaMinimo: polizaConfigZonaMinimo,
        centroTrabajoFonacot: polizaConfigCentroTrabajoFonacot,
        numeroFonacot: polizaConfigNumeroFonacot,
      },
      { headers: this.props.headersToken }
    )
      .then((res) => {
        if (res.data.success === 2) this.setState({ guardandoPolizaConfig: false, currentStep: 8 });
        else { message.error(res.data.message || "No se pudo guardar la configuración"); this.setState({ guardandoPolizaConfig: false }); }
      })
      .catch(() => { message.error("Error al guardar la configuración de póliza"); this.setState({ guardandoPolizaConfig: false }); });
  }

  cargarResumenContableDeLey() {
    this.setState({ loadingResumenContable: true });
    axios.post("wizardNominas/selectResumenContableDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingResumenContable: false,
            resumenContable: res.data.data,
            resumenContableTotales: res.data.resumen || null,
            // Enlace de la entrega de préstamo con la deducción que lo cobra: no es una cuenta,
            // así que viaja aparte del resumen.
            resumenContablePrestamos: res.data.prestamos || [],
          });
        }
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingResumenContable: false }); }
      })
      .catch(() => { message.error("Error al cargar la configuración contable"); this.setState({ loadingResumenContable: false }); });
  }

  guardarResumenContableDeLey() {
    this.setState({ guardandoResumenContable: true });
    axios.post("wizardNominas/agregarResumenContableDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const asignados = res.data.asignados ?? 0;
          const respetados = res.data.respetados ?? 0;
          const prestamosLigados = res.data.prestamosLigados ?? 0;
          const partes = [];
          if (asignados > 0) partes.push(`${asignados} concepto(s) con cuenta asignada`);
          if (respetados > 0) partes.push(`${respetados} respetado(s) sin cambios`);
          if (prestamosLigados > 0) {
            partes.push(`${prestamosLigados} entrega(s) de préstamo ligada(s) a su concepto de cobro`);
          }
          const cuentasPadreCreadas = res.data.cuentasPadreCreadas ?? 0;
          if (cuentasPadreCreadas > 0) partes.push(`${cuentasPadreCreadas} cuenta(s) padre creada(s)`);
          message.success(partes.length > 0 ? partes.join(" · ") : "La configuración contable ya estaba al día");
          this.setState({ guardandoResumenContable: false, currentStep: 9 });
        }
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ guardandoResumenContable: false }); }
      })
      .catch(() => { message.error("Error al guardar la configuración contable"); this.setState({ guardandoResumenContable: false }); });
  }

  cargarTurnos() {
    this.setState({ loadingTurnos: true });
    axios.post("wizardNominas/selectTurnosDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ loadingTurnos: false, turnos: res.data.data });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingTurnos: false }); }
      })
      .catch(() => { message.error("Error al cargar turnos"); this.setState({ loadingTurnos: false }); });
  }

  guardarTurnos() {
    this.setState({ guardandoTurnos: true });
    axios.post("wizardNominas/agregarTurnosDeLey", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ guardandoTurnos: false, currentStep: 11 });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ guardandoTurnos: false }); }
      })
      .catch(() => { message.error("Error al guardar turnos"); this.setState({ guardandoTurnos: false }); });
  }

  cargarTablasGlobales() {
    this.setState({ loadingTablas: true });
    axios.post("wizardNominas/selectTablasGlobales", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ loadingTablas: false, tablas: res.data.data });
        else { message.error(res.data.message || "No se pudo completar la operación"); this.setState({ loadingTablas: false }); }
      })
      .catch(() => { message.error("Error al cargar tablas globales"); this.setState({ loadingTablas: false }); });
  }

  // ─── Step renders ─────────────────────────────────────────────────────────

  renderStep0() {
    const { reingreso } = this.props;
    return (
      <div style={{ textAlign: "center", padding: "20px 0 32px" }}>
        <div style={{
          width: 80, height: 80, borderRadius: "50%", backgroundColor: "#e6f9fb",
          display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 24,
        }}>
          <IconCalendarCog size={42} color="#00BFD6" />
        </div>

        <Title level={2} style={{ marginBottom: 10 }}>
          {reingreso ? "Asistente de Configuración de Nómina" : "Bienvenido a la Configuración de Nómina"}
        </Title>
        <Text type="secondary" style={{ fontSize: 15, display: "block", maxWidth: 560, margin: "0 auto" }}>
          {reingreso
            ? "Entra al paso que necesites para dar de alta lo que te haya quedado pendiente. Los catálogos que ya existen no se duplican."
            : "Antes de empezar a procesar nóminas, necesitas completar una configuración inicial. El asistente te llevará paso a paso por cada sección y solo toma unos minutos."}
        </Text>

        {!reingreso && (
          <div style={{ display: "flex", justifyContent: "center", gap: 40, margin: "32px auto 40px", flexWrap: "wrap" }}>
            {[
              { valor: "~15 min", etiqueta: "Tiempo estimado" },
              { valor: "11 pasos", etiqueta: "Secciones a completar" },
              { valor: "Guiado", etiqueta: "Con asistente paso a paso" },
            ].map((item, i) => (
              <div key={i} style={{ textAlign: "center" }}>
                <div style={{ fontSize: 22, fontWeight: 700, color: "#00BFD6" }}>{item.valor}</div>
                <Text type="secondary" style={{ fontSize: 13 }}>{item.etiqueta}</Text>
              </div>
            ))}
          </div>
        )}

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: 14,
          margin: reingreso ? "32px auto 40px" : "0 auto 40px",
          maxWidth: 820,
          textAlign: "left",
        }}>
          {PASOS_RESUMEN.map((paso, i) => (
            <div
              key={i}
              className={reingreso ? "nomwiz-paso-card" : undefined}
              onClick={reingreso ? () => this.setState({ currentStep: i + 1 }) : undefined}
              style={{
                border: "1px solid #e8e8e8", borderRadius: 8, padding: "16px 18px",
                display: "flex", alignItems: "flex-start", gap: 14, backgroundColor: "#fafafa",
                cursor: reingreso ? "pointer" : undefined,
              }}
            >
              <div style={{
                width: 36, height: 36, borderRadius: "50%", backgroundColor: "#e6f9fb",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#00BFD6", flexShrink: 0,
              }}>
                {paso.icon}
              </div>
              <div>
                <div style={{ fontWeight: 600, marginBottom: 4, fontSize: 13 }}>{i + 1}. {paso.titulo}</div>
                <Text type="secondary" style={{ fontSize: 12 }}>{paso.descripcion}</Text>
              </div>
            </div>
          ))}
        </div>

        <Text type="secondary" style={{ display: "block", marginBottom: 20, fontSize: 13 }}>
          {reingreso
            ? "Haz clic en cualquier paso para entrar directamente, o navega con la barra de pasos de arriba."
            : "Podrás editar cualquier sección después desde las pestañas de configuración."}
        </Text>
        <Button
          type="primary" size="large"
          style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6", paddingLeft: 32, paddingRight: 32 }}
          onClick={() => this.setState({ currentStep: 1 })}
        >
          {reingreso ? "Ir al primer paso →" : "Empezar configuración →"}
        </Button>
        {process.env.NODE_ENV === "development" && (
          <div style={{ marginTop: 16, display: "flex", justifyContent: "center", gap: 8, flexWrap: "wrap" }}>
            {["Tipos Periodo", "Config Periodos", "Acumulados", "Incidencias", "Prestaciones", "Conceptos", "Config. General", "Contabilidad", "Reg. Patronal", "Turno", "Tablas"].map((label, i) => (
              <Button key={i} size="small" onClick={() => this.setState({ currentStep: i + 1 })}>
                {i + 1}. {label}
              </Button>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderStep1() {
    const { tiposSeleccionados } = this.state;
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>¿Qué tipos de periodo de nómina manejas?</Title>
        <Text type="secondary">Puedes seleccionar uno o más. Podrás agregar más tipos después desde la configuración.</Text>
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          {TIPOS_PERIODO.map((tipo) => {
            const selected = tiposSeleccionados.includes(tipo.key);
            return (
              <Col key={tipo.key} xs={24} sm={12}>
                <div
                  onClick={() => this.toggleTipo(tipo.key)}
                  style={{
                    border: `2px solid ${selected ? "#00BFD6" : "#e8e8e8"}`,
                    borderRadius: 8, padding: "18px 20px", cursor: "pointer",
                    backgroundColor: selected ? "#e6f9fb" : "#fafafa",
                    display: "flex", alignItems: "center", gap: 14,
                    transition: "all 0.15s", userSelect: "none",
                  }}
                >
                  <div style={{
                    width: 22, height: 22, borderRadius: "50%",
                    border: `2px solid ${selected ? "#00BFD6" : "#d9d9d9"}`,
                    backgroundColor: selected ? "#00BFD6" : "white",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    {selected && <CheckCircleFilled style={{ color: "white", fontSize: 14 }} />}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 15 }}>{tipo.label}</div>
                    <Text type="secondary" style={{ fontSize: 13 }}>{tipo.descripcion}</Text>
                  </div>
                </div>
              </Col>
            );
          })}
          <Col xs={24} sm={12}>
            <div
              style={{
                border: "2px solid #00BFD6",
                borderRadius: 8, padding: "18px 20px",
                backgroundColor: "#e6f9fb",
                display: "flex", alignItems: "center", gap: 14,
                cursor: "default",
              }}
            >
              <div style={{
                width: 22, height: 22, borderRadius: "50%",
                border: "2px solid #00BFD6",
                backgroundColor: "#00BFD6",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
              }}>
                <CheckCircleFilled style={{ color: "white", fontSize: 14 }} />
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 15 }}>
                  Extraordinario (Finiquito/Aguinaldo) <Tag color="#00BFD6" style={{ marginLeft: 6 }}>Siempre incluido</Tag>
                </div>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  Para finiquitos, aguinaldos y otros pagos fuera de tu calendario regular. Se crea
                  automáticamente; después podrás dar de alta periodos puntuales cuando los necesites
                  desde la sección Periodos.
                </Text>
              </div>
            </div>
          </Col>
        </Row>
        <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 0 })}>← Atrás</Button>
          <Button
            type="primary" size="large"
            disabled={tiposSeleccionados.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.setState({ currentStep: 2, tipoActualIdx: 0 })}
          >
            Siguiente →
          </Button>
        </div>
      </>
    );
  }

  renderConfigTipo(key) {
    const cfg = this.state.configuraciones[key];

    if (key === "semanal") return (
      <div>
        <Text strong>¿Qué día de la semana inicia el periodo?</Text><br />
        <Select value={cfg.diaInicioDeSemana} onChange={(v) => this.setConfiguracion("semanal", "diaInicioDeSemana", v)} style={{ width: 200, marginTop: 8 }}>
          {DIAS_SEMANA.map((d) => <Option key={d.value} value={d.value}>{d.label}</Option>)}
        </Select>
      </div>
    );

    if (key === "quincenal") return (
      <Alert type="info" showIcon
        message="Sin configuración adicional"
        description="Los periodos quincenales corren del 1 al 15 y del 16 al último día del mes automáticamente."
      />
    );

    if (key === "catorcenal") return (
      <div>
        <Text strong>¿Qué día de la semana inicia el primer periodo?</Text><br />
        <Select value={cfg.diaInicioDeSemana} onChange={(v) => this.setConfiguracion("catorcenal", "diaInicioDeSemana", v)} style={{ width: 200, marginTop: 8 }}>
          {DIAS_SEMANA.map((d) => <Option key={d.value} value={d.value}>{d.label}</Option>)}
        </Select>
      </div>
    );

    if (key === "mensual") return (
      <div>
        <Text strong>¿Qué día del mes inicia el periodo?</Text><br />
        <InputNumber min={1} max={28} value={cfg.diaInicio} onChange={(v) => this.setConfiguracion("mensual", "diaInicio", v)} style={{ width: 120, marginTop: 8 }} />
      </div>
    );

    return null;
  }

  renderStep2() {
    const { tiposSeleccionados, tipoActualIdx, guardandoPeriodos } = this.state;
    const key = tiposSeleccionados[tipoActualIdx];
    // Se puede caer aquí saltando directo desde la barra de pasos, sin haber
    // elegido periodicidades en el paso anterior.
    if (!key || !this.state.configuraciones[key]) {
      return (
        <>
          <Title level={4} style={{ marginBottom: 6 }}>Configurar Periodos</Title>
          <Alert
            type="info"
            showIcon
            message="Primero elige las periodicidades"
            description="Selecciona en el paso Tipos de Periodo qué periodicidades manejas para poder configurar sus fechas de inicio."
            style={{ marginBottom: 24 }}
          />
          <Button onClick={() => this.setState({ currentStep: 1 })}>← Ir a Tipos de Periodo</Button>
        </>
      );
    }
    const tipo = TIPOS_PERIODO.find((t) => t.key === key);
    const esUltimo = tipoActualIdx === tiposSeleccionados.length - 1;

    return (
      <>
        <Text type="secondary" style={{ display: "block", marginBottom: 4 }}>
          Tipo {tipoActualIdx + 1} de {tiposSeleccionados.length}
        </Text>
        <Title level={4} style={{ marginBottom: 6 }}>Configurar: {tipo?.label}</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
          Se darán de alta los periodos de los próximos 2 años. Si necesitas más, puedes agregarlos desde la sección Periodos.
        </Text>
        <div style={{ maxWidth: 420 }}>
          <div style={{ marginBottom: 20 }}>
            <Text strong>¿Desde qué fecha quieres iniciar los periodos?</Text><br />
            <DatePicker
              value={this.state.configuraciones[key].fechaInicio}
              onChange={(date) => this.setConfiguracion(key, "fechaInicio", date)}
              disabledDate={getDisabledDate(key, this.state.configuraciones[key])}
              style={{ marginTop: 8, width: 200 }}
              placeholder="Selecciona fecha"
              format="DD/MM/YYYY"
            />
          </div>
          {this.renderConfigTipo(key)}
        </div>
        <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => {
            if (tipoActualIdx > 0) this.setState({ tipoActualIdx: tipoActualIdx - 1 });
            else this.setState({ currentStep: 1 });
          }}>← Atrás</Button>
          <Button
            type="primary" size="large" loading={guardandoPeriodos}
            disabled={!this.state.configuraciones[key]?.fechaInicio}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => {
              if (!esUltimo) this.setState({ tipoActualIdx: tipoActualIdx + 1 });
              else this.guardarPeriodos();
            }}
          >
            {esUltimo ? "Guardar y continuar →" : "Siguiente tipo →"}
          </Button>
        </div>
      </>
    );
  }

  renderStep3() {
    const { acumulados, loadingAcumulados, guardandoAcumulados } = this.state;
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      {
        title: "Tipo", dataIndex: "tipo", key: "tipo", width: 160,
        render: (t) => t === "P" ? "Percepción" : t === "D" ? "Deducción" : t,
      },
    ];
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Tipos Acumulados</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Acumulados estándar para el cálculo anual de ISR e IMSS. Confírmalos para agregarlos a tu empresa.
        </Text>
        {loadingAcumulados
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={acumulados} columns={columns} rowKey="_id" size="small" pagination={false} scroll={{ y: 260 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 2, tipoActualIdx: this.state.tiposSeleccionados.length - 1 })}>← Atrás</Button>
          <Button
            type="primary" loading={guardandoAcumulados}
            disabled={loadingAcumulados || acumulados.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarAcumulados()}
          >
            Confirmar y continuar →
          </Button>
        </div>
      </>
    );
  }

  renderStep4() {
    const { incidencias, loadingIncidencias, guardandoIncidencias } = this.state;
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Tipo", dataIndex: "tipo", key: "tipo", width: 120 },
    ];
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Tipos de Incidencias</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Incidencias estándar: faltas, incapacidades, vacaciones, entre otras. Confírmalas para agregarlas a tu empresa.
        </Text>
        {loadingIncidencias
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={incidencias} columns={columns} rowKey="_id" size="small" pagination={false} scroll={{ y: 260 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 3 })}>← Atrás</Button>
          <Button
            type="primary" loading={guardandoIncidencias}
            disabled={loadingIncidencias || incidencias.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarIncidencias()}
          >
            Confirmar y continuar →
          </Button>
        </div>
      </>
    );
  }

  renderStep5() {
    const { prestaciones, loadingPrestaciones, guardandoPrestaciones } = this.state;
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Descripción", dataIndex: "descripcion", key: "descripcion" },
    ];
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Tipo de Prestaciones</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Paquetes de prestaciones base que establece la Ley Federal del Trabajo. Confírmalos para agregarlos a tu empresa.
        </Text>
        {loadingPrestaciones
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={prestaciones} columns={columns} rowKey="_id" size="small" pagination={false} scroll={{ y: 260 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 4 })}>← Atrás</Button>
          <Button
            type="primary" loading={guardandoPrestaciones}
            disabled={loadingPrestaciones || prestaciones.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarPrestaciones()}
          >
            Confirmar y continuar →
          </Button>
        </div>
      </>
    );
  }

  renderStep6() {
    const { conceptos, loadingConceptos, guardandoConceptos, resumenConceptos } = this.state;
    const columns = [
      { title: "Numero", dataIndex: "numero", key: "numero", width: 90 },
      { title: "Descripcion", dataIndex: "descripcion", key: "descripcion" },
      {
        title: "Tipo", dataIndex: "tipo", key: "tipo", width: 130,
        render: (t) => {
          // El backend manda ya la etiqueta bonita ("Percepción"/"Deducción"/"Obligación",
          // TIPO_LABEL en wizardNomina.js), así que se compara contra eso y no contra
          // "percepcion"/"deduccion" — con lo anterior todas las filas salían azules.
          const color = t === "Percepción" ? "green" : t === "Deducción" ? "red" : "blue";
          return <span style={{ color, fontWeight: 500 }}>{t}</span>;
        },
      },
      {
        title: "Estado", dataIndex: "estadoAlta", key: "estadoAlta", width: 200,
        render: (estado, row) => {
          if (estado === "nuevo") {
            return <span style={{ color: "#00BFD6", fontWeight: 500 }}>Se agregará</span>;
          }
          if (estado === "corregir") {
            // El detalle importa: el usuario tiene que poder auditar por qué le tocamos un
            // concepto que ya tenía dado de alta.
            return (
              <span style={{ color: "#d48806", fontWeight: 500 }}>
                Ya existe — se corregirá
                {row.art174Motivos?.length > 0 && (
                  <span style={{ display: "block", color: "#888", fontWeight: 400, fontSize: 11 }}>
                    {row.art174Motivos.join("; ")}
                  </span>
                )}
                {row.art174Revisar?.length > 0 && (
                  <span style={{ display: "block", color: "#cf1322", fontWeight: 400, fontSize: 11 }}>
                    Revisa a mano: {row.art174Revisar.join("; ")}
                  </span>
                )}
              </span>
            );
          }
          return (
            <span style={{ color: "#888" }}>
              Ya existe
              {/* Una fórmula editada a mano no se toca, pero tampoco puede salir en verde:
                  mientras no lea los domingos, la prima dominical grava de más. */}
              {row.art174Revisar?.length > 0 ? (
                <span style={{ display: "block", color: "#cf1322", fontWeight: 400, fontSize: 11 }}>
                  Revisa a mano: {row.art174Revisar.join("; ")}
                </span>
              ) : row.art174 && (
                <span style={{ display: "block", color: "#52c41a", fontWeight: 400, fontSize: 11 }}>
                  Art. 174 correcto
                </span>
              )}
            </span>
          );
        },
      },
    ];
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Conceptos de Ley</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
          Los siguientes conceptos están definidos por la ley. Confírmalos para agregarlos a tu
          empresa. Los que ya tengas dados de alta no se duplican: sólo se revisa que las
          percepciones del Art. 174 RLISR (aguinaldo, PTU, prima dominical y prima vacacional)
          traigan su bandera y su acumulado de base gravada, y si no, se les pone. En la prima
          dominical también se repara la fórmula de la exención de 1 UMA por domingo; si la
          editaste a mano no se toca, sólo se te avisa.
        </Text>
        {resumenConceptos && (
          <Text style={{ display: "block", marginBottom: 20 }}>
            <b>{resumenConceptos.nuevos}</b> por agregar ·{" "}
            <b>{resumenConceptos.existentes}</b> ya registrados ·{" "}
            <b style={{ color: resumenConceptos.correcciones > 0 ? "#d48806" : undefined }}>
              {resumenConceptos.correcciones}
            </b>{" "}
            por corregir
          </Text>
        )}
        {loadingConceptos
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={conceptos} columns={columns} rowKey="_id" size="small" pagination={false} scroll={{ y: 280 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 5 })}>← Atrás</Button>
          <Button
            type="primary" loading={guardandoConceptos}
            disabled={loadingConceptos || conceptos.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarConceptosDeLey()}
          >
            Confirmar y guardar →
          </Button>
        </div>
      </>
    );
  }

  renderSwitchRow(label, descripcion, checked, onChange) {
    return (
      <div style={{ marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ marginRight: 16 }}>
          <Text strong>{label}</Text><br />
          <Text type="secondary" style={{ fontSize: 12 }}>{descripcion}</Text>
        </div>
        <Switch checked={checked} onChange={onChange} />
      </div>
    );
  }

  renderStep7PolizaNomina() {
    const {
      tiposDePolizasWizard, proyectosWizard, loadingPolizaConfig, guardandoPolizaConfig,
      polizaConfigTipoDePolizaId, polizaConfigProyectoId, polizaConfigPorEmpleado, polizaConfigDesactivarObligaciones,
      polizaConfigNetearSubsEntregado, polizaConfigMetodoISR, polizaConfigAjustarISRRetenidoMenos,
      polizaConfigAjustarISRRetenidoMas, polizaConfigAjustarSubsCausadoMenos, polizaConfigEducacion1Pct,
      polizaConfigAplicarSubsidioArt174,
      polizaConfigMultiploAjusteNeto, polizaConfigPreferenciaAjusteNetoNegativo, polizaConfigPrimaRiesgoTrabajo,
      polizaConfigZonaMinimo, polizaConfigCentroTrabajoFonacot, polizaConfigNumeroFonacot,
    } = this.state;

    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Configuración General de Nómina</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Define cómo se contabiliza y calcula tu nómina. Podrás ajustar todo esto después desde la sección Configuración General.
        </Text>
        {loadingPolizaConfig ? (
          <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
        ) : (
          <div style={{ maxWidth: 460 }}>
            <Title level={5} style={{ marginBottom: 12 }}>Póliza Contable</Title>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Tipo de Póliza</Text><br />
              <Select
                placeholder="Selecciona el tipo de póliza"
                showSearch
                value={polizaConfigTipoDePolizaId}
                onChange={(v) => this.setState({ polizaConfigTipoDePolizaId: v })}
                style={{ width: "100%", marginTop: 8 }}
                filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
              >
                {tiposDePolizasWizard.map((t) => <Option value={t._id} key={t._id}>{t.nombre}</Option>)}
              </Select>
            </div>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Proyecto General</Text><br />
              <Select
                placeholder="Selecciona el proyecto general"
                showSearch
                value={polizaConfigProyectoId}
                onChange={(v) => this.setState({ polizaConfigProyectoId: v })}
                style={{ width: "100%", marginTop: 8 }}
                filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
              >
                {proyectosWizard.map((p) => <Option value={p._id} key={p._id}>{p.nombre}</Option>)}
              </Select>
            </div>

            {this.renderSwitchRow(
              "Generar una póliza por empleado",
              "Si está apagado, se genera una sola póliza general por nómina.",
              polizaConfigPorEmpleado,
              (v) => this.setState({ polizaConfigPorEmpleado: v })
            )}

            {this.renderSwitchRow(
              "Desactivar movimientos de las obligaciones",
              "Si está encendido, la póliza ya no contabiliza el pasivo ni el gasto de los conceptos tipo Obligación (IMSS, INFONAVIT, etc.).",
              polizaConfigDesactivarObligaciones,
              (v) => this.setState({ polizaConfigDesactivarObligaciones: v })
            )}

            <Divider style={{ margin: "4px 0 16px" }} />
            <Title level={5} style={{ marginBottom: 12 }}>Cálculo de ISR</Title>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Método de cálculo de ISR</Text><br />
              <Select
                value={polizaConfigMetodoISR}
                onChange={(v) => this.setState({ polizaConfigMetodoISR: v })}
                style={{ width: "100%", marginTop: 8 }}
              >
                <Option value="SP">Procedimiento (SP)</Option>
                <Option value="mensualizado">Mensualizado</Option>
              </Select>
            </div>

            {this.renderSwitchRow(
              "Ajustar ISR retenido de menos",
              "Al cierre de mes, reintegra al empleado el ISR que se le retuvo de menos durante el mes.",
              polizaConfigAjustarISRRetenidoMenos,
              (v) => this.setState({ polizaConfigAjustarISRRetenidoMenos: v })
            )}

            {this.renderSwitchRow(
              "Ajustar ISR retenido de más",
              "Al cierre de mes, cobra al empleado el ISR que se le retuvo de más durante el mes.",
              polizaConfigAjustarISRRetenidoMas,
              (v) => this.setState({ polizaConfigAjustarISRRetenidoMas: v })
            )}

            {this.renderSwitchRow(
              "Ajustar subsidio causado de menos",
              "Al cierre de mes, incluye el subsidio al empleo causado de menos dentro del ajuste de ISR del mes.",
              polizaConfigAjustarSubsCausadoMenos,
              (v) => this.setState({ polizaConfigAjustarSubsCausadoMenos: v })
            )}

            {this.renderSwitchRow(
              "Restar subsidio en la tasa del Art. 174",
              "Resta el subsidio al empleo en las dos corridas de tarifa que forman la tasa efectiva del Art. 174 RLISR (aguinaldo, PTU, prima dominical y prima vacacional). Déjalo apagado salvo que necesites empatar con un NOMIPAQ que traiga esta bandera activa.",
              polizaConfigAplicarSubsidioArt174,
              (v) => this.setState({ polizaConfigAplicarSubsidioArt174: v })
            )}

            {this.renderSwitchRow(
              "Netear subsidio entregado",
              "Cambia cómo se calcula el subsidio entregado que no correspondía al cierre de mes.",
              polizaConfigNetearSubsEntregado,
              (v) => this.setState({ polizaConfigNetearSubsEntregado: v })
            )}

            {this.renderSwitchRow(
              "Aplicar 1% de impuesto estatal de educación",
              "Activa el cálculo de un impuesto estatal adicional del 1% sobre la base gravable + exenta de ISR.",
              polizaConfigEducacion1Pct,
              (v) => this.setState({ polizaConfigEducacion1Pct: v })
            )}

            <Divider style={{ margin: "4px 0 16px" }} />
            <Title level={5} style={{ marginBottom: 12 }}>Ajuste de Neto</Title>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Múltiplo de redondeo del neto</Text><br />
              <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                El neto a pagar se redondea al múltiplo más cercano de este valor. Déjalo en 0 para desactivar el redondeo.
              </Text>
              <InputNumber
                min={0} step={0.05}
                value={polizaConfigMultiploAjusteNeto}
                onChange={(v) => this.setState({ polizaConfigMultiploAjusteNeto: v })}
                style={{ width: "100%" }}
              />
            </div>

            {this.renderSwitchRow(
              "Preferir ajuste negativo en empate",
              "Cuando el residuo cae exactamente a la mitad del múltiplo: encendido = redondea hacia arriba; apagado = redondea hacia abajo.",
              polizaConfigPreferenciaAjusteNetoNegativo,
              (v) => this.setState({ polizaConfigPreferenciaAjusteNetoNegativo: v })
            )}

            <Divider style={{ margin: "4px 0 16px" }} />
            <Title level={5} style={{ marginBottom: 12 }}>IMSS y Salarios Mínimos</Title>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Prima de riesgo de trabajo</Text><br />
              <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                Fracción decimal (0.005 = 0.5%, clase I mínima). Se usa solo cuando el Registro Patronal del empleado no tiene una prima vigente ni clase de riesgo asignada.
              </Text>
              <InputNumber
                min={0} max={1} step={0.001}
                value={polizaConfigPrimaRiesgoTrabajo}
                onChange={(v) => this.setState({ polizaConfigPrimaRiesgoTrabajo: v })}
                style={{ width: "100%" }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Zona de salarios mínimos</Text><br />
              <Select
                value={polizaConfigZonaMinimo}
                onChange={(v) => this.setState({ polizaConfigZonaMinimo: v })}
                style={{ width: "100%", marginTop: 8 }}
              >
                <Option value="A">Zona A</Option>
                <Option value="B">Zona B</Option>
                <Option value="C">Zona C</Option>
              </Select>
            </div>

            <Divider style={{ margin: "4px 0 16px" }} />
            <Title level={5} style={{ marginBottom: 12 }}>Fonacot</Title>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Centro de Trabajo Fonacot</Text><br />
              <Input
                value={polizaConfigCentroTrabajoFonacot}
                onChange={(e) => this.setState({ polizaConfigCentroTrabajoFonacot: e.target.value })}
                style={{ marginTop: 8 }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <Text strong>Número Fonacot</Text><br />
              <Input
                value={polizaConfigNumeroFonacot}
                onChange={(e) => this.setState({ polizaConfigNumeroFonacot: e.target.value })}
                style={{ marginTop: 8 }}
              />
            </div>
          </div>
        )}
        <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 6 })}>← Atrás</Button>
          <Button
            type="primary" size="large" loading={guardandoPolizaConfig}
            disabled={loadingPolizaConfig || !polizaConfigTipoDePolizaId || !polizaConfigProyectoId}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarPolizaConfig()}
          >
            Guardar y continuar →
          </Button>
        </div>
      </>
    );
  }

  renderStep7Contable() {
    const {
      resumenContable, loadingResumenContable, guardandoResumenContable, resumenContableTotales,
      resumenContablePrestamos,
    } = this.state;

    // El enlace de una entrega de préstamo con la deducción que lo cobra no es una cuenta, así que
    // el resumen de arriba lo reporta como "ya asignado" y no lo toca. En una empresa que sembró
    // el concepto antes de que existiera la opción, esto es lo único que este paso va a cambiar —
    // y es lo que hace que el saldo del préstamo por empleado se pueda leer.
    const prestamosPorLigar = (resumenContablePrestamos || []).filter((p) => p.estado === "porLigar");

    const formatCuenta = (cuenta) => {
      if (!cuenta) return <Text type="secondary" style={{ fontSize: 12 }}>—</Text>;
      const codigo = `${cuenta.nivel1}.${cuenta.nivel2}`;
      const descripcion = cuenta.descripcionExistente || cuenta.descripcionPropuesta;
      return (
        <span>
          <span style={{ fontFamily: "monospace", fontSize: 12, marginRight: 6 }}>{codigo}</span>
          {descripcion}
          {" "}
          {cuenta.existe
            ? <Tag color="green" style={{ marginLeft: 4 }}>Ya existe</Tag>
            : <Tag color="blue" style={{ marginLeft: 4 }}>Se creará</Tag>}
        </span>
      );
    };

    const columns = [
      { title: "Concepto", dataIndex: "descripcion", key: "descripcion" },
      {
        title: "Tipo", dataIndex: "tipo", key: "tipo", width: 110,
        render: (t) => {
          const color = t === "Percepción" ? "green" : t === "Deducción" ? "red" : "blue";
          return <span style={{ color, fontWeight: 500 }}>{t}</span>;
        },
      },
      { title: "Cuenta de Costo/Gasto", dataIndex: "cuentaCostoGasto", key: "cuentaCostoGasto", render: formatCuenta },
      { title: "Cuenta de Pasivo", dataIndex: "cuentaPasivo", key: "cuentaPasivo", render: formatCuenta },
      {
        title: "Por empleado", dataIndex: "generarCuentaPorEmpleado", key: "generarCuentaPorEmpleado", width: 100, align: "center",
        render: (v) => v ? <CheckCircleFilled style={{ color: "#00BFD6" }} /> : <Text type="secondary">—</Text>,
      },
      {
        title: "Estado", dataIndex: "estadoAsignacion", key: "estadoAsignacion", width: 210,
        render: (estado, row) => {
          if (estado === "sinCuentas") return <Text type="secondary">Sin cuentas de ley</Text>;
          if (estado === "sinConcepto") {
            return <Text type="secondary" style={{ fontSize: 12 }}>El concepto aún no existe</Text>;
          }
          if (estado === "porAsignar") {
            return <span style={{ color: "#00BFD6", fontWeight: 500 }}>Se asignará</span>;
          }
          // Ya asignado: mostrar QUÉ se respeta, para que se vea que no se pisa nada.
          const actuales = [row.cuentaActualCostoGasto, row.cuentaActualPasivo].filter(Boolean);
          return (
            <span style={{ color: "#888" }}>
              Ya asignada — no se toca
              {actuales.length > 0 && (
                <span style={{ display: "block", color: "#888", fontWeight: 400, fontSize: 11 }}>
                  {actuales.map((c) => `${c.codigo} ${c.descripcion}`).join(" · ")}
                </span>
              )}
            </span>
          );
        },
      },
    ];

    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Configuración Contable</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
          Estas son las cuentas contables que se asignarán a cada concepto de nómina. Las que no
          existan en tu catálogo se crearán al confirmar. <b>Los conceptos que ya tengan cuenta
          asignada no se modifican</b>, aunque sea una cuenta distinta a la de ley: este paso sólo
          llena lo que está vacío, así que puedes volver a correrlo sin perder tus ajustes.
        </Text>
        {resumenContableTotales && (
          <Text style={{ display: "block", marginBottom: 20 }}>
            <b>{resumenContableTotales.porAsignar}</b> por asignar ·{" "}
            <b>{resumenContableTotales.yaAsignados}</b> ya asignados (se respetan)
            {resumenContableTotales.sinConcepto > 0 && (
              <>
                {" · "}
                <b style={{ color: "#d48806" }}>{resumenContableTotales.sinConcepto}</b> sin
                concepto todavía
              </>
            )}
          </Text>
        )}
        {prestamosPorLigar.length > 0 && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message="Se va a corregir la contabilización de la entrega de préstamos"
            description={
              <span>
                {prestamosPorLigar.map((p) => (
                  <div key={p.descripcion}>
                    <b>{p.descripcion}</b> se va a ligar a <b>{p.cobroDescripcion}</b>.
                  </div>
                ))}
                <div style={{ marginTop: 8 }}>
                  Con el enlace, el cargo de la entrega va a la misma subcuenta por empleado en la
                  que la deducción abona las amortizaciones, al proyecto general y sin traspaso
                  intercentro. Así el saldo del préstamo de cada persona se lee directo de esa
                  cuenta; sin él, el cargo se quedaba en la cuenta mayor y la subcuenta del empleado
                  acumulaba puros abonos.
                </div>
              </span>
            }
          />
        )}
        {loadingResumenContable
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={resumenContable} columns={columns} rowKey="numero" size="small" pagination={false} scroll={{ y: 320 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 7 })}>← Atrás</Button>
          <Button
            type="primary" loading={guardandoResumenContable}
            disabled={loadingResumenContable || resumenContable.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarResumenContableDeLey()}
          >
            Confirmar y continuar →
          </Button>
        </div>
      </>
    );
  }

  renderStep7() {
    const { modalRegistroPatronal, registroPatronalAgregado } = this.state;
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Registro Patronal</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          El Registro Patronal es el número con el que el IMSS identifica a tu empresa como patrón. Es necesario para timbrar nómina.
        </Text>

        {registroPatronalAgregado ? (
          <div style={{
            padding: "20px 24px", borderRadius: 8, backgroundColor: "#f6ffed",
            border: "1px solid #b7eb8f", display: "flex", alignItems: "center", gap: 14,
          }}>
            <IconFile size={28} color="#52c41a" />
            <div>
              <Text strong style={{ color: "#389e0d", display: "block" }}>Registro Patronal agregado correctamente</Text>
              <Text type="secondary" style={{ fontSize: 13 }}>Puedes agregar más desde la pestaña Registro Patronal en la configuración.</Text>
            </div>
          </div>
        ) : (
          <div style={{
            padding: "24px 20px", border: "1px dashed #b5e8f0", borderRadius: 8,
            backgroundColor: "#f6fdfe", display: "flex", alignItems: "flex-start", gap: 16,
          }}>
            <IconFile size={32} color="#00BFD6" />
            <div>
              <Text strong style={{ display: "block", marginBottom: 6 }}>
                ¿Deseas agregar tu Registro Patronal ahora?
              </Text>
              <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
                Necesitarás el número de registro del IMSS, clase de riesgo y prima de riesgo.
                Si no lo tienes a la mano puedes configurarlo después.
              </Text>
              <Button
                type="primary"
                style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
                onClick={() => this.setState({ modalRegistroPatronal: true })}
              >
                Agregar Registro Patronal
              </Button>
            </div>
          </div>
        )}

        <AgregarRegistroPatronal
          visible={modalRegistroPatronal}
          cerrarAgregarRegistroPatronal={() => this.setState({ modalRegistroPatronal: false })}
          onGuardado={() => this.setState({ registroPatronalAgregado: true, modalRegistroPatronal: false })}
        />

        <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 8 })}>← Atrás</Button>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {!registroPatronalAgregado && (
              <Button type="link" style={{ color: "#8c8c8c" }} onClick={() => this.setState({ currentStep: 10 })}>
                Configurar después
              </Button>
            )}
            <Button
              type="primary"
              style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
              onClick={() => this.setState({ currentStep: 10 })}
            >
              Continuar →
            </Button>
          </div>
        </div>
      </>
    );
  }

  renderStep8() {
    const { turnos, loadingTurnos, guardandoTurnos } = this.state;
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Horas", dataIndex: "horasTurno", key: "horasTurno", width: 80 },
    ];
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Turno</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Los siguientes turnos de trabajo se agregarán como base. Podrás crear más desde la sección Turnos en la configuración.
        </Text>
        {loadingTurnos
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={turnos} columns={columns} rowKey="_id" size="small" pagination={false} scroll={{ y: 260 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 9 })}>← Atrás</Button>
          <Button
            type="primary" loading={guardandoTurnos}
            disabled={loadingTurnos || turnos.length === 0}
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.guardarTurnos()}
          >
            Confirmar y continuar →
          </Button>
        </div>
      </>
    );
  }

  renderStep9() {
    const { tablas, loadingTablas } = this.state;
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Tipo", dataIndex: "tipo", key: "tipo", width: 300 },
    ];
    return (
      <>
        <Title level={4} style={{ marginBottom: 6 }}>Tablas del SAT</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Las siguientes tablas ya están disponibles de forma global en BIWO y puedes usarlas de inmediato.
          Si necesitas agregar tablas adicionales hazlo desde la sección <Text strong>Tablas</Text>.
        </Text>
        {loadingTablas
          ? <div style={{ textAlign: "center", padding: 48 }}><Spin /></div>
          : <Table dataSource={tablas} columns={columns} rowKey="_id" size="small" pagination={false} scroll={{ y: 260 }} />
        }
        <div style={{ marginTop: 24, display: "flex", justifyContent: "space-between" }}>
          <Button onClick={() => this.setState({ currentStep: 10 })}>← Atrás</Button>
          <Button
            type="primary" size="large"
            style={{ backgroundColor: "#00BFD6", borderColor: "#00BFD6" }}
            onClick={() => this.props.onComplete()}
          >
            {this.props.reingreso ? "Volver a la configuración ✓" : "Finalizar configuración ✓"}
          </Button>
        </div>
      </>
    );
  }

  renderAnimation() {
    const { animPhase } = this.state;
    return (
      <div className={"nomwiz-anim" + (animPhase === 5 ? " nomwiz-anim-out" : "")}>
        <div className="nomwiz-anim-rings">
          {[1, 2, 3, 4].map((n) => <div key={n} className="nomwiz-ring" />)}
        </div>
        <div className="nomwiz-anim-stage">
          <div className={"nomwiz-anim-icon" + (animPhase >= 1 ? " nomwiz-anim-icon-show" : "")}>
            <IconBiwo size={110} marginRight={0} color="#00BFD6" />
          </div>
          <div className="nomwiz-anim-brand">
            <span className={"nomwiz-anim-biwo" + (animPhase >= 2 ? " show" : "")}>biwo</span>
            <span className={"nomwiz-anim-mod" + (animPhase >= 3 ? " nomwiz-mod-show" : "")}>
              {animPhase >= 3 && (
                <>
                  <span className="nomwiz-spark spark-1" />
                  <span className="nomwiz-spark spark-2" />
                  <span className="nomwiz-spark spark-3" />
                  <span className="nomwiz-spark spark-4" />
                  <span className="nomwiz-spark spark-5" />
                </>
              )}
              Nómina
            </span>
          </div>
          <p className={"nomwiz-anim-sub" + (animPhase >= 4 ? " show" : "")}>
            Tu nómina, simple y en orden
          </p>
        </div>
        <button className="nomwiz-skip" onClick={this._skip}>Omitir</button>
      </div>
    );
  }

  render() {
    const { currentStep, showAnim } = this.state;
    const { reingreso } = this.props;

    const STEPS = ["Inicio", "Tipos de Periodo", "Configurar Periodos", "Tipos Acumulados", "Tipos de Incidencias", "Tipo de Prestaciones", "Conceptos de Ley", "Configuración General", "Configuración Contable", "Registro Patronal", "Turno", "Tablas"];
    const content = [
      this.renderStep0(),
      this.renderStep1(),
      this.renderStep2(),
      this.renderStep3(),
      this.renderStep4(),
      this.renderStep5(),
      this.renderStep6(),
      this.renderStep7PolizaNomina(),
      this.renderStep7Contable(),
      this.renderStep7(),
      this.renderStep8(),
      this.renderStep9(),
    ];

    return (
      <div style={{ backgroundColor: "white", borderRadius: 8, padding: currentStep === 0 ? "40px" : "32px 40px" }}>
        {showAnim && this.renderAnimation()}
        {reingreso && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <Button
              type="link"
              style={{ paddingLeft: 0 }}
              disabled={currentStep === 0}
              onClick={() => this.setState({ currentStep: 0 })}
            >
              ← Todos los pasos
            </Button>
            <Button onClick={() => this.props.onSalir()}>Salir del asistente</Button>
          </div>
        )}
        {currentStep > 0 && (
          <Steps
            current={currentStep - 1}
            size="small"
            style={{ marginBottom: 40 }}
            onChange={(i) => this.setState({ currentStep: i + 1 })}
          >
            {STEPS.slice(1).map((s, i) => <Steps.Step key={i} title={s} />)}
          </Steps>
        )}
        <div style={{ maxWidth: currentStep === 0 ? 900 : 680, margin: currentStep === 0 ? "0 auto" : undefined }}>
          {content[currentStep]}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionInicialWizard);
